import transactionApiClient from "./TransactionApiClient";
import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

export const ExchangeRequestService = {
    async createExchangeRequest(exchangeRequestDto) {
        const response = await axios.post(`${API_URL}/api/exchange-requests`, exchangeRequestDto);
        return response.data;
    },

    async getAllExchangeRequests() {
        const response = await transactionApiClient.get(`${API_URL}/api/exchange-requests`);
        return response.data;
    },
};
